<template>
  <div class="main container">
    <CompanyProfile v-if="accountType === 'business'" :company="currentCompany"/>

    <IndividualProfile v-else :userDetails="currentUser"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import CompanyProfile from '@/containers/business_profile/CompanyProfile'
import IndividualProfile from '@/containers/individual_profile/IndividualProfile'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
  components: {
    CompanyProfile,
    IndividualProfile
  },
  data() {
    return {
      accountType: auth.getAccountType()
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'currentCompany']),
  },
  mounted() { }
}
</script>



// WEBPACK FOOTER //
// src/containers/dashboard/Profile.vue